import React from 'react';
import { getArrayFromSize } from '../../core/utils/array';

const shimmerArray = getArrayFromSize(2);

export function GlobalSearchEntityListShimmer() {
  return (
    <>
      {shimmerArray.map((key, index) => (
        <div
          role='presentation'
          key={index}
          data-id="global-search-entity-list-shimmer"
          className='center-flex-row justify-between pl-5'
          style={{ height: 56 }}
        >
          <div className='center-flex-row'>
            <div className='shimmer shimmer-circle mr-3' />

            <div className='shimmer shimmer-line' style={{ width: 130 }} />
          </div>

          <div className='center-flex-row mr-9'>
            <div className='shimmer shimmer-circle mr-3' />
            <div className='shimmer shimmer-line' style={{ width: 130 }} />
          </div>
        </div>
      ))}
    </>
  );
}
